{
  "columns": [
    {
      "header_id": "tasBillingBatchClaimDetailId",
      "header_label": "Batch claim detail Id",
      "jsonpath": "tasBillingBatchClaimDetailId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "batchName",
      "header_label": "Batch Name",
      "jsonpath": "batchName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "parentClaimDetailId",
      "header_label": "Parent CLaim detail Id",
      "jsonpath": "parentClaimDetailId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "adjustedClaimDetailId",
      "header_label": "Adjuste claim detail Id",
      "jsonpath": "adjustedClaimDetailId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "pplIcn",
      "header_label": "PPL ICN",
      "jsonpath": "pplIcn",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "extIcn",
      "header_label": "External ICN",
      "jsonpath": "extIcn",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "participantPplId",
      "header_label": "Consumer PPL Id",
      "jsonpath": "participantPplId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "participantId",
      "header_label": "Participant Id",
      "jsonpath": "participantId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "mcoParticipantId",
      "header_label": "MCO participant Id",
      "jsonpath": "mcoParticipantId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "medicaidParticipantId",
      "header_label": "Medicaid Participant Id",
      "jsonpath": "medicaidParticipantId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "participantCounty",
      "header_label": "Participant County",
      "jsonpath": "participantCounty",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "mcoName",
      "header_label": "Payer Name",
      "jsonpath": "mcoName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "serviceCode",
      "header_label": "Service Code",
      "jsonpath": "serviceCode",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "serviceDate",
      "header_label": "Service Date",
      "jsonpath": "serviceDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "pmpmMonthYear",
      "header_label": "Month-Year",
      "jsonpath": "pmpmMonthYear",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "pmpmBilledDate",
      "header_label": "PMPM Billed Date",
      "jsonpath": "pmpmBilledDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "units",
      "header_label": "Billed Units",
      "jsonpath": "units",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "totalCharges",
      "header_label": "Billed Amount",
      "jsonpath": "totalCharges",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "resubFlg",
      "header_label": "Resubmitted",
      "jsonpath": "resubFlg",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "statusDescription",
      "header_label": "Status",
      "jsonpath": "statusDescription",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "timesheets",
      "header_label": "Timesheets",
      "jsonpath": "timesheets",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "timesheetsCount",
      "header_label": "Timesheets count",
      "jsonpath": "timesheetsCount",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "billableRate",
      "header_label": "Billable Rate",
      "jsonpath": "billableRate",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "providerId",
      "header_label": "Provider Id",
      "jsonpath": "providerId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "authNumber",
      "header_label": "Auth Number",
      "jsonpath": "authNumber",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "sysVoidFlg",
      "header_label": "System Void",
      "jsonpath": "sysVoidFlg",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "pmpmFlg",
      "header_label": "PMPM",
      "jsonpath": "pmpmFlg",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "createddate",
      "header_label": "Created Date",
      "jsonpath": "createddate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "pmpmPaidDate",
      "header_label": "PMPM Paid Date",
      "jsonpath": "pmpmPaidDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "paymentDate",
      "header_label": "MCO Paid Date",
      "jsonpath": "paymentDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    }
  ],
  "buttons": [],
  "apiDetails": "claims.json",
  "pageName": "billingPMPMClaimsListView",
  "orderByColumn": ["tasBillingBatchClaimDetailId"],
  "orderBy": ["desc"]
}
